exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".questions {\n  padding: 25px 30px 25px 18px;\n  border-radius: 8px;\n  border: none;\n  box-shadow: 0 2px 10px 0 rgba(111, 111, 111, 0.4);\n  margin-top: 10px;\n  width: auto;\n}\n.questions-title {\n  text-align: left;\n  display: inline;\n}\n.visible {\n  height: 18px;\n  width: 18px;\n  float: right;\n}\n.invisible {\n  height: 18px;\n  width: 18px;\n  float: right;\n}", ""]);

// exports
